import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=ebac964e&scoped=true"
import script from "./sign.vue?vue&type=script&lang=js"
export * from "./sign.vue?vue&type=script&lang=js"
import style0 from "./sign.vue?vue&type=style&index=0&id=ebac964e&prod&scoped=true&lang=css"
import style1 from "./sign.vue?vue&type=style&index=1&id=ebac964e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebac964e",
  null
  
)

export default component.exports